import { useEffect } from "react";
import PropTypes from "prop-types";
import { X, CheckCircle, AlertCircle, Info } from "lucide-react";
import styles from "./Toast.module.scss";

const Toast = ({ message, type = "success", onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const icons = {
    success: CheckCircle,
    error: AlertCircle,
    info: Info,
  };

  const Icon = icons[type] || Info;

  return (
    <div className={`${styles.toast} ${styles[type]}`}>
      <Icon size={20} className={styles.icon} />
      <span className={styles.message}>{message}</span>
      <button onClick={onClose} className={styles.closeButton}>
        <X size={16} />
      </button>
    </div>
  );
};

Toast.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(["success", "error", "info"]),
  onClose: PropTypes.func.isRequired,
  duration: PropTypes.number,
};

export default Toast;
